 <!--Snooze Functionality-->
 <div class="pop-up" id="snooze-popup">
    <div class="top-row">
        <div class="form-heading">Snooze This Action</div>
        <img class="hover-pointer" src="assets/close-icon.svg" alt="exit-icon" (click)="exitCover()">
    </div>
    <div class="content-box">
        <div class="question-text">
            Remind me about "{{recName}}" again in...
        </div>
        <form name="snooze">
            <div class="flex" *ngFor="let months of [3, 6, 9, 12]">
                <input title="months + 'Months'" placeholder="months + 'Months'" label="months + 'Months'" type="radio" [id]="months + 'Months'" [value]="months + ' Months'" (click)="updateSnoozeFormValue(months)">
                <label [for]="months + 'Months'">{{months}} Months</label><br>
            </div>
        </form>
    </div>
    <div class="bottom-row">
        <div class="cancel hover-pointer" (click)="exitCover()">Cancel</div>
        <div class="submit hover-pointer" (click)="submitSnooze()">Submit</div>
    </div>
</div>